import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
    selector: 'app-dialog-content',
    templateUrl: './dialog-content.component.html',
    styleUrls: ['./dialog-content.component.scss'],
    standalone: true,
    imports: [MatDialogModule, TranslocoModule, MatButtonModule]
})
export class DialogContentComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
}
